/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserInviteTenantRoles {
    getFixupPrototypeFunction() { return UserInviteTenantRoles.fixupPrototype; }

    static newInstance(model: Partial<UserInviteTenantRoles>): UserInviteTenantRoles {
        let obj = Object.assign(new UserInviteTenantRoles(), model);
        UserInviteTenantRoles.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserInviteTenantRoles>): UserInviteTenantRoles {
        if (!model) return null;
        return UserInviteTenantRoles.newInstance(<UserInviteTenantRoles> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserInviteTenantRoles) {
        if (!obj) return;

        models.UserInviteTenantRoles.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserInviteTenantRoles): boolean {
        Object.setPrototypeOf(obj, UserInviteTenantRoles.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant within the CoreStack account
     */
    tenant_id: string;

    /**
     * Ids of the Roles to be assigned to the user under a tenant
     */
    role_ids: Array<string>;

}
